import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function FA_mobile_view_curriculum_page() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className='fs-6'>1. Fundamentals and Treasury</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          What is the Treasury?, Functions and roles of Treasury, Corporations and other corporates, Treasury as an activity, How Treasury management is implemented in Banks, NBFCs, Micro-Financial.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className='fs-6'>2. Corporate Finance</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Capital Structure, Capital Ratios, Credit Assessment for Financing Decision, Basics of financing decisions and their importance.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className='fs-6'>3. Corporate portfolio management</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Basics and Introduction, Why do corporations Invest in other businesses?, Liquidity, Credit and Market Risk, Investment Management, Formulation and application of Investment Policy.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className='fs-6'>4. Financial risk management</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Introduction to Financial Risks, Hedging Ratios, Price Movement Analysis, Risk Mitigation Techniques, Currency, Interest Rates and Commodity Risk.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
        >
          <Typography className='fs-6'>5. Application of financial ratio in day-to-day operations</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Three financial management decisions, Quantitative modeling, Analysis of financial models and statements, Techniques of taking data-driven decisions.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel6bh-content"
          id="panel6bh-header"
        >
          <Typography className='fs-6'>6. Cash and liquidity management</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Liquidity management, Cash forecasting, Physical and Notional sash pools, POBO/ROBO models, Clearing and Settlement systems.  
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel7bh-content"
          id="panel7bh-header"
        >
          <Typography className='fs-6'>7. SCM - Supply Chain Management</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Working Capital Management, Cash Conversion Cycle, Receipts and Payables outstanding/indents and requisitions outstanding, Letter of Credit, Bank Guarantee, Discounting, Factoring and Forfeiting, Legal terms, Regulatory and Compliances.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel8bh-content"
          id="panel8bh-header"
        >
          <Typography className='fs-6'>8. MINOR & MAJOR PROJECT</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Minor Project, Major Project, Project Overview.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
